import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { DesktopLayoutComponent } from "./desktop/layout/desktop-layout.component";
import { DesktopDashboardComponent } from "./pages/dashboard/dashboard.component";
import { FinancialDocumentsComponent } from "./pages/financial-documents/financial-documents.component";
import { SaleComponent } from "./pages/sale/sale.component";
import { SaleTripComponent } from "./pages/sale/sale-trip/sale-trip.component";
import { FlyTicketComponent } from "./pages/sale/fly-ticket/fly-ticket.component";
import { SaleVoucherComponent } from "./pages/sale/sale-voucher/sale-voucher.component";
import { ReturnComponent } from "./pages/return/return.component";
import { RedirectComponent } from "./pages/redirect/redirect.component";
import { ForbiddenComponent } from "./pages/forbidden/forbidden.component";
import { UnauthorizedComponent } from "./pages/unauthorized/unauthorized.component";
import { authGuard } from "./guards/auth.guard";
import { FlyTicketType } from "./enums/fly-ticket-type.enum";
import { ClosingsDashboardComponent } from "./pages/closings/closings-dashboard.component";
import { ReportsComponent } from "./pages/reports/reports.component";
import { MovementReportComponent } from "./pages/reports/movement-report/movement-report.component";
import { ValuablesReportComponent } from "./pages/reports/valuables-report/valuables-report.component";
import { MoneyClosingComponent } from "./pages/closings/money-closing/money-closing.component";
import { ValuablesClosingComponent } from "./pages/closings/valuables-closing/valuables-closing.component";
import { ReportContainerComponent } from "./pages/reports/report-container/report-container.component";
import { AuthorizationPolicy } from "./guards/authorization-policy";



const routes: Routes = [
  {
    path: "",
    redirectTo: "/dashboard",
    pathMatch: "full",
  },
  {
    path: "",
    component: DesktopLayoutComponent,
    children: [
      {
        path: "dashboard",
        component: DesktopDashboardComponent,
        data: { pageTitle: "webPos.Dashboard" }
      },
      {
        path: "financial-documents",
        component: FinancialDocumentsComponent,
        canActivate: [authGuard],
        data: { pageTitle: "webPos.FinancialDocuments", authorizationPolicy: AuthorizationPolicy.FinancialDocuments }
      },
      {
        path: "reports",
        component: ReportsComponent,
        canActivate: [authGuard],
        data: { pageTitle: "webPos.Reports", authorizationPolicy: AuthorizationPolicy.PosAccess }
      },
      {
        path: "reports/movement-report",
        component: MovementReportComponent,
        canActivate: [authGuard],
        data: { pageTitle: "webPos.MovementReport", backRoute: "reports", authorizationPolicy: AuthorizationPolicy.PosAccess }
      },
      {
        path: "reports/valuables-report",
        component: ValuablesReportComponent,
        canActivate: [authGuard],
        data: { pageTitle: "webPos.ValuablesReport", backRoute: "reports", authorizationPolicy: AuthorizationPolicy.PosAccess }
      },
      {
        path: "sale",
        component: SaleComponent,
        canActivate: [authGuard],
        data: { pageTitle: "webPos.saleTrans", authorizationPolicy: AuthorizationPolicy.Sale }
      },
      {
        path: "closings",
        component: ClosingsDashboardComponent,
        canActivate: [authGuard],
        data: { pageTitle: "webPos.Closings.DashboardTitle", authorizationPolicy: AuthorizationPolicy.PosAccess }
      },
      {
        path: "closings/money-closing",
        component: MoneyClosingComponent,
        canActivate: [authGuard],
        data: { pageTitle: "webPos.Closings.MoneyBackButton", backRoute: "closings", authorizationPolicy: AuthorizationPolicy.PosAccess }
      },
      {
        path: "closings/valuables-closing",
        component: ValuablesClosingComponent,
        canActivate: [authGuard],
        data: { pageTitle: "webPos.Closings.ValuablesShort", backRoute: "closings", authorizationPolicy: AuthorizationPolicy.PosAccess }
      },
      {
        path: "trip/:id?",
        component: SaleTripComponent,
        canActivate: [authGuard],
        data: { type: "sale", pageTitle: "webPos.Trip.TripNavigation", backRoute: "sale", authorizationPolicy: AuthorizationPolicy.Sale },
      },
      {
        path: "trip",
        component: SaleTripComponent,
        canActivate: [authGuard],
        data: { type: "sale", pageTitle: "webPos.Trip.TripNavigation", backRoute: "sale", authorizationPolicy: AuthorizationPolicy.Sale },
      },
      {
        path: "fly-ticket/:id",
        component: FlyTicketComponent,
        canActivate: [authGuard],
        data: { type: "sale", viewType: FlyTicketType.FlyTicket, pageTitle: "webPos.FlyTicketNavigation", backRoute: "sale", authorizationPolicy: AuthorizationPolicy.Sale },
      },
      {
        path: "fly-ticket",
        component: FlyTicketComponent,
        canActivate: [authGuard],
        data: { type: "sale", viewType: FlyTicketType.FlyTicket, pageTitle: "webPos.FlyTicketNavigation", backRoute: "sale", authorizationPolicy: AuthorizationPolicy.Sale },
      },
      {
        path: "e-travel/:id",
        component: FlyTicketComponent,
        canActivate: [authGuard],
        data: { type: "sale", viewType: FlyTicketType.ETravel, pageTitle: "webPos.ETravel", backRoute: "sale", authorizationPolicy: AuthorizationPolicy.Sale },
      },
      {
        path: "e-travel",
        component: FlyTicketComponent,
        canActivate: [authGuard],
        data: { type: "sale", viewType: FlyTicketType.ETravel, pageTitle: "webPos.ETravel", backRoute: "sale", authorizationPolicy: AuthorizationPolicy.Sale },
      },
      {
        path: "voucher/:id",
        component: SaleVoucherComponent,
        canActivate: [authGuard],
        data: { pageTitle: "webPos.Voucher.Voucher", backRoute: "sale", authorizationPolicy: AuthorizationPolicy.Sale }
      },
      {
        path: "voucher",
        component: SaleVoucherComponent,
        canActivate: [authGuard],
        data: { pageTitle: "webPos.Voucher.Voucher", backRoute: "sale", authorizationPolicy: AuthorizationPolicy.Sale }
      },
      {
        path: "return",
        component: ReturnComponent,
        canActivate: [authGuard],
        data: { pageTitle: "webPos.Return", authorizationPolicy: AuthorizationPolicy.Return }
      },
      {
        path: "trip-return",
        component: SaleTripComponent,
        canActivate: [authGuard],
        data: { type: "return", pageTitle: "webPos.Trip.TripRefundNavigation", backRoute: "return", authorizationPolicy: AuthorizationPolicy.Return },
      },
      {
        path: "trip-return/:id",
        component: SaleTripComponent,
        canActivate: [authGuard],
        data: { type: "return", pageTitle: "webPos.Trip.TripRefundNavigation", backRoute: "return", authorizationPolicy: AuthorizationPolicy.Return },
      },
      {
        path: "fly-ticket-return",
        component: FlyTicketComponent,
        canActivate: [authGuard],
        data: { type: "return", viewType: FlyTicketType.FlyTicket, pageTitle: "webPos.FlyTicketRefundNavigation", backRoute: "return", authorizationPolicy: AuthorizationPolicy.Return },
      },
      {
        path: "fly-ticket-return/:id",
        component: FlyTicketComponent,
        canActivate: [authGuard],
        data: { type: "return", viewType: FlyTicketType.FlyTicket, pageTitle: "webPos.FlyTicketRefundNavigation", backRoute: "return", authorizationPolicy: AuthorizationPolicy.Return },
      },
      {
        path: "e-travel-return",
        component: FlyTicketComponent,
        canActivate: [authGuard],
        data: { type: "return", viewType: FlyTicketType.ETravel, pageTitle: "webPos.ETravelRefund", backRoute: "return", authorizationPolicy: AuthorizationPolicy.Return },
      },
      {
        path: "e-travel-return/:id",
        component: FlyTicketComponent,
        canActivate: [authGuard],
        data: { type: "return", viewType: FlyTicketType.ETravel, pageTitle: "webPos.ETravelRefund", backRoute: "return", authorizationPolicy: AuthorizationPolicy.Return },
      },
      {
        path: "voucher-return/:id",
        component: SaleVoucherComponent,
        canActivate: [authGuard],
        data: { type: "voucherReturn", pageTitle: "webPos.Voucher.VoucherRefund", backRoute: "return", authorizationPolicy: AuthorizationPolicy.Return },
      },
      {
        path: "report/:name",
        component: ReportContainerComponent,
        canActivate: [authGuard],
        data: { type: "report", pageTitle: "webPos.Report", backRoute: "reports", authorizationPolicy: AuthorizationPolicy.PosAccess },
      },
      {
        path: "redirect",
        component: RedirectComponent,
        data: { pageTitle: "webPos.Redirect" }
      },
      {
        path: "forbidden",
        component: ForbiddenComponent,
        data: { pageTitle: "webPos.Forbidden" }
      },
      {
        path: "unauthorized",
        component: UnauthorizedComponent,
        data: { pageTitle: "webPos.Unauthorized" }
      },
      // {
      //   path: "**",
      //   redirectTo: "dashboard",
      // },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
